"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentSideModelToJSON = exports.AttachmentSideModelFromJSONTyped = exports.AttachmentSideModelFromJSON = exports.AttachmentSideModel = void 0;
/**
 * The side of the image.
 * @export
 * @enum {string}
 */
var AttachmentSideModel;
(function (AttachmentSideModel) {
    AttachmentSideModel["FRONT"] = "FRONT";
    AttachmentSideModel["BACK"] = "BACK";
})(AttachmentSideModel = exports.AttachmentSideModel || (exports.AttachmentSideModel = {}));
function AttachmentSideModelFromJSON(json) {
    return AttachmentSideModelFromJSONTyped(json, false);
}
exports.AttachmentSideModelFromJSON = AttachmentSideModelFromJSON;
function AttachmentSideModelFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AttachmentSideModelFromJSONTyped = AttachmentSideModelFromJSONTyped;
function AttachmentSideModelToJSON(value) {
    return value;
}
exports.AttachmentSideModelToJSON = AttachmentSideModelToJSON;
//# sourceMappingURL=AttachmentSideModel.js.map